<template>
  <main id="payouts-list" class="site-main">
    <div class="grid-container">
      <div class="page-header grid-x grid-padding-x align-middle">
        <div class="cell auto">
          <h1 class="page-header__title">Payouts</h1>

<!--          <div class="text-right">-->
<!--            <span class="icon-action" @click="exportPayouts">-->
<!--              <i class="far fa-arrow-to-bottom"></i> <span>Export</span>-->
<!--            </span>-->
<!--          </div>-->
        </div>
      </div>

      <div class="panel no-padding">
        <searchBar placeholder="Search payouts" @sort="sort" :value="searchValue"
                   @search="search"></searchBar>

        <div :class="['loading-area', loading ? 'loading' : '']">
          <div :class="['loading-area__content', loading ? 'loading' : '']">
            <pagination :prev="prev" :next="next" :start="start" :end="end"
                        :total="total"
                        @paginate="paginate"></pagination>

            <tableList :header="tableHeader" :data="tableData" :loading="loading"
                       @callback="callback" @post="go"
                       @sort="orderBy"></tableList>

            <pagination :prev="prev" :next="next" :start="start" :end="end"
                        :total="total"
                        @paginate="paginate"></pagination>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import { PREFIX } from '@/localSettings'

import moment from 'moment'

export default {
  mixins: [client, paginationUtils],
  data: function () {
    return {
      action: '/vendors/payouts/?vendor_id=' + this.$store.state.vendors[this.$store.state.currentVendor].id,
      sort: '-created_date',
      tableHeader: {
        currentSort: '-amount',
        data: [
          {
            label: 'Amount',
            class: 'medium',
            sort: 'amount',
            sortStart: '-'
          },
          {
            label: 'Note',
            class: 'full'
          },
          {
            label: 'Date',
            class: 'large',
            sort: 'created_date',
            sortStart: '-'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    exportPayouts () {
      this.request('get', '/vendors/payouts/', {
        vendor_id: this.vendor_id,
        ordering: '-created_date',
        format: 'csv'
      }).then((response) => {
        let downloadLink = document.createElement('a')

        let data = encodeURI(response)

        downloadLink.href = '/download/?' + data
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      })
    },
    go: function (id) {
      this.$router.push(PREFIX + '/payouts/' + id)
    },
    buildTable () {
      for (let i = 0; i < this.data.length; i++) {
        let row = {
          post: this.data[i].id,
          data: [
            {
              value: this.formatMoney(this.data[i].amount),
              class: 'medium focus-text'
            },
            {
              value: this.data[i].note,
              class: 'full'
            },
            {
              value: moment(this.data[i].created_date).format('MMM D, YYYY [at] h:mma'),
              class: 'large'
            }
          ]
        }

        this.tableData.push(row)
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/mixins';
@import '../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/payouts.vue